import CButton from "components/CButton";
import CDialog from "components/CDialog";
import useTracker from "components/CTracker/useTrackerContext";
import useAnnuncementCoborrower from "./useAnnuncementCoborrower";

const AnnuncementCreateNewOfferPending = () => {
  const { handleAddAnnuncementCreateNewOfferPending, loading, openModal } =
    useAnnuncementCoborrower();
  const { loan } = useTracker();

  return (
    <CDialog
      fullWidth
      maxWidth="xs"
      icon="warning"
      scroll={"paper"}
      sx={{ padding: "2rem" }}
      title="Final offer"
      description={loan?.borrowerSteps?.createNewOfferVerification?.message}
      open={openModal}
      onClose={handleAddAnnuncementCreateNewOfferPending}
    >
      <CButton
        fullWidth
        loading={loading}
        disabled={loading}
        onClick={handleAddAnnuncementCreateNewOfferPending}
        variant="contained"
      >
        Accept
      </CButton>
    </CDialog>
  );
};

export default AnnuncementCreateNewOfferPending;
